<template>
  <div class="patient-inline-link">
    <div v-if="submission.PatNum" class="d-flex align-items-center">
      <div
        class="avatar"
        :class="getAvatarClass(submission.PatNum)"
        :style="getPatientAvatar(submission.PatNum) ? `background-image: url(${getPatientAvatar(submission.PatNum)})` : ''"
      >
        {{ !getPatientAvatar(submission.PatNum) ? getInitials(getPatientWithDOB(submission.PatNum)) : '' }}
      </div>
      <router-link :to="{ name: 'patientprofile', params: {patientID: `${siteID}-${submission.PatNum}`} }" target="_blank" class="patient-link" @click.stop>
        {{ getPatientWithDOB(submission.PatNum) }}
      </router-link>
    </div>

    <div v-else class="not-linked">
      <div class="link-pill" role="button" tabindex="0" @click.stop="$emit('open-link-modal', submission.FormSubmissionIDForWeb)" @keydown.enter.stop="$emit('open-link-modal', submission.FormSubmissionIDForWeb)">
        <i class="fa fa-link"></i>
        <span class="pill-text">Not linked — Link patient</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PatientInlineLink',
  props: {
    submission: { type: Object, required: true },
    siteID: { type: String, required: true }
  },
  computed: {
    // patients are stored in the `customer` module
    ...mapState('customer', ['patients'])
  },
  methods: {
    // helper utilities re-used from parent mixin expectations
    getPatientWithDOB(patNum) {
      const p = this.patients && this.patients.find(x => x.PatNum === patNum);
      return p ? p.PatientWithDOB || p.Patient : '';
    },
    getPatientAvatar(patNum) {
      const p = this.patients && this.patients.find(x => x.PatNum === patNum);
      return p && p.PictureUrl ? p.PictureUrl : null;
    },
    getInitials(name) {
      if (!name) return '';
      const parts = name.split(',')[0].trim().split(' ');
      return parts.map(p => p.charAt(0)).join('').substr(0,2).toUpperCase();
    },
    getAvatarClass(patNum) {
      // simple deterministic class
      const colors = ['bg-primary text-white','bg-success text-white','bg-info text-white','bg-warning text-white','bg-danger text-white','bg-gray text-white'];
      let hash = 0; for (let i=0;i<patNum.toString().length;i++) hash = patNum.toString().charCodeAt(i) + ((hash<<5)-hash);
      return colors[Math.abs(hash) % colors.length];
    }
  }
}
</script>

<style scoped>
.patient-inline-link {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.patient-inline-link .link-pill {
  display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border-radius:20px;background:#eef2f7;color:#0f172a;cursor:pointer;border:1px dashed #cbd5e1;font-size:0.9rem;margin-right:8px;
}
.patient-inline-link .pill-text{font-weight:600}
.inline-editor{display:flex;align-items:center;gap:8px;max-width:360px}
.inline-editor{position:absolute;left:8px;top:50%;transform:translateY(-50%);background:#fff;padding:8px;border-radius:6px;box-shadow:0 6px 18px rgba(16,24,40,0.08);z-index:2500}
.avatar{width:32px;height:32px;border-radius:50%;display:inline-flex;justify-content:center;align-items:center;margin-right:8px}

/* Ensure multiselect dropdown appears above table and doesn't push layout */
::v-deep .multiselect__content-wrapper {
  z-index: 4000 !important;
  min-width: 180px !important;
  max-width: 320px !important;
}

/* Constrain inline multiselect size so the Link button doesn't overlap date column */
::v-deep .multiselect {
  min-width: 180px;
  max-width: 320px;
  width: 220px;
}

/* Prevent inline buttons from wrapping */
.inline-editor .btn { white-space: nowrap; }
</style>
